// extracted by mini-css-extract-plugin
export default {"faqPage":"faq_faqPage__sn9pr","container":"faq_container__Ue4i6","pageTitle":"faq_pageTitle__mB7nR","faqGrid":"faq_faqGrid__3WyTG"};